var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41667 17.4167H9.58333V13.9167H13.0833V12.75H9.58333V9.25H8.41667V12.75H4.91667V13.9167H8.41667V17.4167ZM0.833332 21.5V0.5H11.9167L17.1667 5.75V21.5H0.833332ZM11.3333 6.33333H16L11.3333 1.66667V6.33333Z",
    fill: "#1D2951",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector (3).14c3696f0766e3c943db42e1ba479b7b.svg";
export { ForwardRef as ReactComponent };